import ApiService from '@/services/api';

// TYPES
export type TUpdateLicenseEmployeeResponse = unknown;
export type TUpdateLicenseEmployeeBody = {
  has_license: boolean;
};

// FUNCTION

/**
 * Hands a company seat to a user, or takes it back.
 *
 * The same endpoint as the profile update - the serializer checks the seat
 * against the licence capacity and answers 400 when the company is full.
 */
export const updateLicenseEmployee = async (
  requestBody: TUpdateLicenseEmployeeBody,
  companyId: number,
  employeeId: number,
): Promise<TUpdateLicenseEmployeeResponse> => {
  const endpoint = `/v1/companies/${companyId}/employees/${employeeId}/update-info/`;
  const response = await ApiService.put(endpoint, requestBody);
  return response;
};
